<template>
  <swiper id="gallerys" class="gallery-swiper " :options="options" ref="gallerySwiper">
    <swiper-slide v-for="item in info">
      <img :src="item.src" alt="" :data-original="item.thumb">
    </swiper-slide>
    <div class="swiper-pagination" slot="pagination"></div>
    <div class="swiper-button-next swiper-button-white" slot="button-prev"></div>
    <div class="swiper-button-prev swiper-button-white" slot="button-next"></div>
  </swiper>
  
</template>

<script>
import Viewer from 'viewerjs'
import{swiper,swiperSlide} from "vue-awesome-swiper"
export default {
  name: 'fullGallery',
  props: {
    showpath: String,
    info:Array,
  },
  components:{
    swiper,swiperSlide
  },
  
  data(){
    return{
      options:{
        slidesPerView: 1,
        initialSlide:0,
        observer:true,
        observeParents:true,
        pagination:{
          el:'.gallery-swiper .swiper-pagination',
          clickablue:true
        },
        navigation: {
          nextEl: '.gallery-swiper .swiper-button-next',
          prevEl: '.gallery-swiper .swiper-button-prev'
        }
      },
      swiperIndex:0
    }
  },
  computed:{
    gallerySwiper(){
      return this.$refs.gallerySwiper.swiper
    }
  },
  mounted() {
    setTimeout(() => {
      this._initGallery();
      this._initViewer()
    }, 300);
    
  },
  methods: {
    updateSwiper(){
      setTimeout(() => {
        this.gallerySwiper && this.gallerySwiper.update()
      }, 280);
    },
    _initGallery(){
      setTimeout(() => {
        this.gallerySwiper.init()
      }, 1000);
    },
    
    //初始化放大图集
    _initViewer(){
      const viewer = new Viewer(document.querySelector('#gallerys'),{
        // navbar:false,
        // movable:false,
        url: 'data-original',
        fullscreen:true,
        button:true,
        
      })
    },
  },
}
</script>
<style  >

.swiper-button-next.swiper-button-disabled, .swiper-button-prev.swiper-button-disabled{
  pointer-events:auto;
  cursor:not-allowed;
}

</style>